<app-navbar [producerLink]="producerLink()" [hostLink]="hostLink()">
    <div class="tenant-interactive-selects">
        @if (navbarService.selectedTenant()?.tenantLogoUrl; as logoUrl) {
            <img [src]="logoUrl" alt="Tenant logo" class="tenant-logo" />
        }
        @if (navbarService.allTenants().length) {
            <mat-form-field class="tenant-select">
                <mat-label>Select tenant</mat-label>
                <mat-select
                    panelWidth="fit-content"
                    [value]="navbarService.tenantId()"
                    (selectionChange)="onTenantChange($event.value)"
                >
                    @for (
                        tenant of navbarService.allTenants();
                        track tenant.id
                    ) {
                        <mat-option [value]="tenant.id">
                            {{ tenant.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        @if (navbarService.allInteractives().length) {
            <mat-form-field class="interactive-select">
                <mat-label>Select interactive</mat-label>
                <!--
                    Angular Material explicitly says [multiple] must not change after initialization or it resets the value.
                    Use @if/@else to render two separate mat-select instances with static multiple attributes
                -->
                @if (navbarService.isMultiSelectInteractive()) {
                    <mat-select
                        multiple
                        panelWidth="fit-content"
                        [value]="navbarService.selectedInteractiveIds()"
                        (selectionChange)="onInteractiveChange($event.value)"
                    >
                        <mat-select-trigger>
                            {{ selectedInteractivesLabel() }}
                        </mat-select-trigger>
                        @for (
                            interactive of navbarService.allInteractives();
                            track interactive.id
                        ) {
                            <mat-option
                                [value]="interactive.id"
                                [disabled]="
                                    isInteractiveOptionDisabled(interactive)
                                "
                            >
                                <span class="interactive-option-name">
                                    {{ interactive.name }}
                                </span>
                                <span class="interactive-option-type">
                                    {{ interactiveTypeLabel(interactive) }}
                                </span>
                            </mat-option>
                        }
                    </mat-select>
                } @else {
                    <mat-select
                        panelWidth="fit-content"
                        [value]="navbarService.selectedInteractiveIds()[0]"
                        (selectionChange)="onInteractiveChange($event.value)"
                    >
                        <mat-select-trigger>
                            {{ selectedInteractivesLabel() }}
                        </mat-select-trigger>
                        @for (
                            interactive of navbarService.allInteractives();
                            track interactive.id
                        ) {
                            <mat-option [value]="interactive.id">
                                <span class="interactive-option-name">
                                    {{ interactive.name }}
                                </span>
                                <span class="interactive-option-type">
                                    {{ interactiveTypeLabel(interactive) }}
                                </span>
                            </mat-option>
                        }
                    </mat-select>
                }
            </mat-form-field>
        }
    </div>
    @if (navbarService.activeView() === "producer") {
        <tools-button
            [variant]="ButtonVariant.OUTLINE"
            (onClick)="refresh()"
            class="refresh-btn"
        >
            Refresh
        </tools-button>
    }
</app-navbar>
<router-outlet></router-outlet>
@if (!navbarService.allTenants().length) {
    <div class="no-interactives">
        <h3>No Tenants Available</h3>
    </div>
} @else if (
    !navbarService.allInteractives().length && navbarService.tenantId()
) {
    <div class="no-interactives">
        <h3>No Interactives Yet</h3>
        @if (canCreateInteractive()) {
            <p>Create your first interactive to get started.</p>
            <tools-button
                routerLink="/interactives/new"
                class="create-interactive-btn"
            >
                Create New Interactive
            </tools-button>
        }
    </div>
}
